import React from 'react';

import { UserHeader } from 'components/common/Header';
import RenderComponent from 'components/common/RenderComponent';
import { makeStyles } from 'tss-react/mui';

export interface CreatingOrderLayoutProps {
  frame?: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  mobileTop: {
    [theme.breakpoints.down('sm')]: {
      position: 'sticky',
      top: 0,
      width: '100%',
      zIndex: 200,
    },
  },
}));

const CreatingOrderLayout: React.FC<React.PropsWithChildren<CreatingOrderLayoutProps>> = (props) => {
  const { isLoading, frame, children } = props;
  const { classes } = useStyles();
  return (
    <>
      {!frame && (
        <div className={classes.mobileTop}>
          <UserHeader hasSearch={false} hasMarketSelect={false} />
        </div>
      )}
      <RenderComponent layout isLoading={isLoading} renderContent={() => children} />
    </>
  );
};

export default CreatingOrderLayout;
